import { useTranslation } from "react-i18next";


// styles
require("./ConfirmationPopup.css");

interface Props {

    header: string;
    text: string;
    handleClose: any;
    handleConfirmation: any;
}

export const ConfirmationPopup = (props: Props) => {
    const { t }: { t: any } = useTranslation();
    return <div style={{ width: '100%', height: '100%' }}>
        <div className="overlay" id="popupOverlay" style={{ display: 'block' }}></div>
        <div className="ZVConfirmationPopup center">
            <div className="card">
                <h5 style={{ textAlign: 'center', padding: '10px', borderBottom: '1px solid lightgray' }}>{props.header}</h5>
                <div className="body" style={{ textAlign: 'center', padding: '10px' }}>
                    {props.text}
                </div>
                <div className="operations" style={{ textAlign: 'center' }}>
                    <input type="button" className="btn btn-sm btn-secondary ripple-surface"
                        value={t('General.DeletionPopup.Cancel')} onClick={() => { props.handleClose(); }} />
                    <input type="button" className="btn btn-sm btn-primary"
                        value={t('General.DeletionPopup.Ok')} onClick={() => { props.handleConfirmation(); }} />
                </div>
            </div>
        </div>
    </div>;
}